// src/components/Confirm.js
import React from 'react';
import Modal from './Modal';

/**
 * Confirm modal (now supports custom content).
 * Backwards compatible:
 * - onConfirm is treated as onOk
 * - okText/okLabel and cancelText/cancelLabel supported
 */
export default function Confirm({
  open,
  title = 'Confirm',
  message,
  children,
  onCancel,
  onOk,
  onConfirm,
  okText,
  cancelText,
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  className,
  bodyClassName,
}) {
  if (!open) return null;

  const ok = onOk || onConfirm;
  const _okLabel = okText || okLabel;
  const _cancelLabel = cancelText || cancelLabel;

  return (
    <Modal title={title} onClose={onCancel} className={className || "max-w-xl"} bodyClassName={bodyClassName}>
      {message ? <p className="mb-4">{message}</p> : null}
      {children ? <div className="mb-4">{children}</div> : null}

      <div className="flex justify-end gap-2">
        <button
          className="px-4 py-2 rounded bg-white/10 hover:bg-white/15"
          onClick={onCancel}
        >
          {_cancelLabel}
        </button>
        <button
          className="px-4 py-2 rounded bg-teal-600 hover:bg-teal-500 text-white"
          onClick={ok}
        >
          {_okLabel}
        </button>
      </div>
    </Modal>
  );
}
